import script from "./ConfigureMappingsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureMappingsStep.vue?vue&type=script&setup=true&lang=js"

import "./ConfigureMappingsStep.vue?vue&type=style&index=0&id=9bd0dede&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bd0dede"]])

export default __exports__